export default __webpack_public_path__ + "static/media/C2_30_x_30_Blanc.0d2db2f1.jpg";